import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_elite-connect-41/artifacts/6qh3fzwr_A33CD683-086F-4DB4-8845-6753BDD1F42D.JPG";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex flex-col justify-end overflow-hidden grain">
      <img
        src={HERO_IMG}
        alt="Formula One car on a floodlit circuit at night"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-black/30" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 w-full pb-24 pt-40">
        <p
          data-testid="hero-tagline"
          className="font-mono-tech text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#F7F6F2] mb-6"
        >
          Where Brands Take Position
        </p>
        <h1
          data-testid="hero-headline"
          className="font-heading font-light uppercase tracking-tight leading-[1.02] text-5xl sm:text-6xl lg:text-8xl text-[#F7F6F2] max-w-4xl"
        >
          Partnerships in Sport<span className="text-[#F7F6F2]">.</span>
        </h1>
        <p
          data-testid="hero-subheadline"
          className="mt-8 max-w-xl text-base sm:text-lg font-light text-neutral-300 leading-relaxed"
        >
          QUALIVE connects ambitious brands with leading teams, clubs and
          sporting properties across Formula One and football.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="inline-flex items-center justify-center font-mono-tech text-xs uppercase tracking-[0.2em] bg-[#F7F6F2] text-[#0A0A0A] px-8 py-4 hover:bg-white transition-colors duration-200"
          >
            Discuss a Partnership
          </a>
          <a
            href="#services"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center justify-center font-mono-tech text-xs uppercase tracking-[0.2em] border border-white/30 text-[#F7F6F2] px-8 py-4 hover:border-[#F7F6F2] transition-colors duration-200"
          >
            Our Work
          </a>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 w-full pb-10 flex items-center gap-3 text-neutral-500">
        <ArrowDown size={14} className="animate-bounce" />
        <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em]">Scroll</span>
      </div>
    </section>
  );
}
